import { render, staticRenderFns } from "./WaitingList.vue?vue&type=template&id=079ff527&scoped=true&"
import script from "./WaitingList.vue?vue&type=script&lang=js&"
export * from "./WaitingList.vue?vue&type=script&lang=js&"
import style0 from "./WaitingList.vue?vue&type=style&index=0&id=079ff527&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079ff527",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDataTable,VPagination,VProgressLinear,VSelect})
